module.exports = __webpack_public_path__ + "img/mask_group.021a78fe.svg";